export default function({ $gtm, app }) {
  const { locale } = app.i18n;
  const gtmContainerId =
    app.$config[`GTM_CONTAINER_ID_${locale.toUpperCase()}`] || null;

  if (gtmContainerId) {
    $gtm.init(gtmContainerId);
  }
}
